import { render } from "./TwoFactorAuthentication.vue?vue&type=template&id=6e8894b2&scoped=true"
import script from "./TwoFactorAuthentication.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthentication.vue?vue&type=script&lang=js"

import "./TwoFactorAuthentication.vue?vue&type=style&index=0&id=6e8894b2&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e8894b2"]])

export default __exports__